import React from 'react'
import './GroundStats.scss'
import useTranslation from '../useTranslation'

export default function GroundStats({ lineups, backgroundColor, foregroundColor }) {

    const GroundStats = useTranslation('Ground Stats')

    if (! lineups || ! lineups.venue) {
        return null;
    }

    const { av_fours, av_score, av_sixes, high_batter, high_score } = lineups.venue || {};

    if (av_fours === 0 && av_score === 0 && av_sixes === 0 && high_batter === 0 && high_score === 0) {
        return null;
    }

    return (
        <div className="ground">
            <div className="ground-title" style={{
                    backgroundColor: foregroundColor,
                    color: backgroundColor
                }}>
                    {GroundStats}
                </div>
                <div className="ground-inner">
                    <div>
                        <div>Average Innings Runs</div> 
                        <div>{av_score}</div>
                    </div>

                    <div>
                        <div>Average Innings Fours</div> 
                        <div>{av_fours}</div>
                    </div>

                    <div>
                        <div>Average Innings Sixes</div> 
                        <div>{av_sixes}</div>
                    </div>

                    <div>
                        <div>Highest Team Score</div> 
                        <div>{high_score}</div>
                    </div>

                    <div>
                        <div>Highest Individual Score</div> 
                        <div>{high_batter}</div>
                    </div>
                </div>
        </div>
    )
}
